import { render, staticRenderFns } from "./ListaAlunos.vue?vue&type=template&id=aed82eb8"
import script from "./ListaAlunos.vue?vue&type=script&lang=js"
export * from "./ListaAlunos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports